import {
  formatReplacementDemandNumber,
  formatReplacementDemandUnits,
} from '../../../lib/replacementDemandShiftHelpers';

export function ReplacementDemandShiftRecipientRail({ recipientGroups }) {
  return (
    <aside className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Top replacement recipients</h3>
        <p className="mt-1 text-xs text-gray-500">
          Use this rail to see which new SKUs inherit the most demand from discontinued catalog exits.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {recipientGroups.length > 0 ? (
          recipientGroups.map(group => (
            <div
              key={group.replacementSku}
              className="rounded-md border border-gray-200 bg-white px-1.5 py-1.5 lg:px-3 lg:py-3"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-gray-900">{group.replacementSku}</p>
                  <p className="mt-1 truncate text-xs text-gray-500">{group.replacementProductName}</p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatReplacementDemandNumber(group.sourceCount)} inbound rule
                    {group.sourceCount === 1 ? '' : 's'}
                  </p>
                </div>
                <p className="text-sm font-semibold text-gray-900">
                  {formatReplacementDemandUnits(group.incomingUnits)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No replacement demand rows are in scope for the current filters.
          </div>
        )}
      </div>
    </aside>
  );
}
